module.exports = __webpack_public_path__ + "img/BAU Seniors_9.c8d1f71d.jpg";